const SESSION_UUID_REGEX =
	/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const isValidSessionUuid = (value: string | null | undefined): value is string =>
	Boolean(value && SESSION_UUID_REGEX.test(value));

export const sanitizeSessionUuids = (sessionUuids?: string[] | null): string[] | undefined => {
	const valid = sessionUuids?.filter(isValidSessionUuid) ?? [];
	return valid.length > 0 ? valid : undefined;
};
